module.exports = __webpack_public_path__ + "static/media/28DGC8.ff1de5df.jpg";